// Export without redux connection
import TutorialPage2 from "./TutorialPage2";

export default TutorialPage2;
